import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PriceRange {
  min: number;
  max: number;
}

export interface FilterStateObj {
  price?: PriceRange | string | string[];
  brandIds?: string[];
  category?: string | string[];
  search?: string;
  sort?: string;
  currentPage?: number;
  perPage?: number;
  color?: string | string[];
  size?: string | string[];
  diet?: string | string[];
  brand?: string | string[];
  decorationMethod?: string | string[];
  productionDays?: string | string[];
  itemFeatures?: string | string[];
  "item-type"?: string | string[];
}

const DEFAULT_OBJ: FilterStateObj = {};

export const filterSlice = createSlice({
  name: "filter",
  initialState: DEFAULT_OBJ,
  reducers: {
    setFilterState: (state, action: PayloadAction<FilterStateObj>) => {
      return action.payload;
    },
    updateFilterState: (state, action: PayloadAction<Partial<FilterStateObj>>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setFilterState, updateFilterState } = filterSlice.actions;

export const filterReducer = filterSlice.reducer;
